import { render, staticRenderFns } from "./CompGeneralFeaturedCard.vue?vue&type=template&id=1f8bb8a4&scoped=true"
import script from "./CompGeneralFeaturedCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGeneralFeaturedCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompGeneralFeaturedCard.vue?vue&type=style&index=0&id=1f8bb8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8bb8a4",
  null
  
)

export default component.exports